import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import Article from './views/Article.vue'
import List from './views/List.vue'
import Object from './views/Object.vue'
import PartnerCalendar from './views/PartnerCalendar.vue'
import Meta from 'vue-meta'

Vue.use(Meta)
Vue.use(Router)

let router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/*_page.html',
      component: Article,
      name: 'article',
      props: (route) => {
        let urlParts = route.path.split('_')
        return {
          lang: urlParts[urlParts.length - 2],
          id: urlParts.filter((urlPart, index) => index <= urlParts.length - 3).join('_').replace('/', '')
        }
      }
    },
    {
      path: '/*_object.html',
      component: Object,
      name: 'object',
      props: (route) => {
        let urlParts = route.path.split('_')
        return {
          lang: urlParts[urlParts.length - 2],
          id: urlParts.filter((urlPart, index) => index <= urlParts.length - 3).join('_').replace('/', '')
        }
      }
    },
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/:lang',
      name: 'homewlang',
      component: Home
    },
    {
      path: '/:lang/article/:articleId',
      name: 'article',
      component: Article
    },
    {
      path: '/:lang/calendar/:objectId',
      name: 'calendar',
      component: PartnerCalendar
    },
    {
      path: '/:lang/search/:query',
      name: 'search',
      component: List
    },
    {
      path: '/:lang/object/:object_id',
      name: 'object',
      component: Object
    },
    {
      path: '/:lang/*',
      name: 'homewlang',
      component: Home
    },
  ]
})

// const setTitle = (to) => {
  // if (!['article', 'object'].includes(to.name)) {
  //  document.title = 'to-be-changed'
  // }
// }

// router.beforeEach((to, from, next) => {
//   setTitle(to)
//   console.log('to', to, from, next)
//   next()
// })

export default router
